import { useTranslation } from 'react-i18next'

import { PkgShippingMethod } from '@/api/user-package/types/UserPkg'
import environment from '@/environment'
import { getShippingMethodLabel } from '@/helpers/pkgUtils'
import { ShippingPrices } from '@/helpers/priceChart'

import { OptionCard } from './OptionCard'

interface Props {
  selectedMethod: string
  onSelectMethod: (methodId: PkgShippingMethod) => void
  packageValue: number
  shippingPrices?: ShippingPrices
}

export const ShippingMethodSelector = ({ selectedMethod, onSelectMethod, shippingPrices }: Props) => {
  const { t } = useTranslation()
  const doorToDoorPrice = parseInt(shippingPrices?.doorToDoor?.toString() || '0')
  const pickUpPointPrice = parseInt(shippingPrices?.pickUpPoint?.toString() || '0')
  const isPickUpPointAvailable = pickUpPointPrice > 0

  const shippingMethods = [
    {
      id: PkgShippingMethod.DoorToDoor,
      name: getShippingMethodLabel(PkgShippingMethod.DoorToDoor, t),
      description: t('payment.deliveryDays'),
      price: doorToDoorPrice,
    },
    {
      id: PkgShippingMethod.PickUpPoint,
      name: getShippingMethodLabel(PkgShippingMethod.PickUpPoint, t),
      description: isPickUpPointAvailable ? t('payment.deliveryDays') : t('payment.pickupPointUnavailable'),
      price: pickUpPointPrice,
      disabled: !isPickUpPointAvailable,
    },
    ...(environment.isStaging || environment.isDev
      ? [
          {
            id: PkgShippingMethod.Test,
            name: getShippingMethodLabel(PkgShippingMethod.Test, t),
            description: t('payment.deliveryDays'),
            price: 0.1,
          },
        ]
      : []),
  ]

  const getPriceDisplay = (price: number, isAvailable: boolean) => {
    if (!isAvailable) return t('payment.notAvailable')
    if (price > 0) return `$${price}`
    return t('payment.loading')
  }

  return (
    <div className='space-y-3'>
      {shippingMethods.map(method => (
        <OptionCard
          key={method.id}
          onSelect={() => onSelectMethod(method.id)}
          selected={selectedMethod === method.id}
          title={method.name}
          description={method.description}
          endContent={<p>{getPriceDisplay(method.price, !method.disabled)}</p>}
          disabled={method.disabled}
        />
      ))}
    </div>
  )
}
